module.exports = __webpack_public_path__ + "img/desk4.e9c8db2b.png";